var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 1.66664H14.9998L13.5707 0H6.42903L5 1.66664H0V3.33328H20L19.9998 1.66664ZM1.99977 17.8573C2.01473 18.4354 2.30357 18.9853 2.80331 19.3867C3.30287 19.7881 3.97274 20.0085 4.66669 19.9997H15.333C16.027 20.0085 16.6968 19.7881 17.1963 19.3867C17.6961 18.9853 17.985 18.4354 17.9999 17.8573V4.99991H1.99989L1.99977 17.8573Z",
    fill: "#F74C4C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRedIcon);
export default __webpack_public_path__ + "static/media/trash-red-icon.19e7d654f7e49e684f69e73816c039f4.svg";
export { ForwardRef as ReactComponent };